/** Язык по id перевода — как в api/data/languages.json. */
const LANGUAGE_BY_TRANSLATION = {
  synodal: 'ru',
  nrt: 'ru',
  kjv: 'en',
  web: 'en',
  lut1912: 'de',
  neg: 'fr',
  rv1909: 'es',
  almeida: 'pt',
  irv1990: 'it',
  pbg: 'pl',
  kor: 'ko',
};

const DEFAULT_TRANSLATION = {
  ru: 'synodal',
  en: 'kjv',
  de: 'lut1912',
  fr: 'neg',
  es: 'rv1909',
  pt: 'almeida',
  it: 'irv1990',
  pl: 'pbg',
  ko: 'kor',
};

/** Язык, если ни Telegram, ни браузер не дали поддерживаемого. */
export const FALLBACK_UI_LANGUAGE = 'ru';

/** Ссылки бота без перевода в startapp («43_3_16») всегда ведут в Синодальный. */
export const START_PARAM_DEFAULT_TRANSLATION = 'synodal';

const LANGUAGE_KEY = 'bibleLanguage';
const TRANSLATION_KEY = 'bibleTranslation';
const LANGUAGE_CHOSEN_KEY = 'bibleLanguageChosen';
const TRANSLATION_CHOSEN_KEY = 'bibleTranslationChosen';

function supported(code) {
  const lang = String(code || '').slice(0, 2).toLowerCase();
  return DEFAULT_TRANSLATION[lang] ? lang : null;
}

function telegramUser() {
  return window.Telegram?.WebApp?.initDataUnsafe?.user || null;
}

function fromBrowser() {
  const list = Array.isArray(navigator.languages) && navigator.languages.length ? navigator.languages : [navigator.language];
  for (const code of list) {
    const lang = supported(code);
    if (lang) return lang;
  }
  return null;
}

/** В Telegram — язык Telegram, в вебе — браузера; иначе русский. */
export function detectUiLanguage() {
  const tgUser = telegramUser();
  const detected = tgUser ? supported(tgUser.language_code) : fromBrowser();
  return detected || FALLBACK_UI_LANGUAGE;
}

/** Пользователь сам выбрал язык (настройки, профиль) — больше не определяем автоматически. */
export function rememberLanguageChoice(code) {
  if (typeof window === 'undefined' || !code) return;
  try {
    localStorage.setItem(LANGUAGE_KEY, String(code).toLowerCase());
    localStorage.setItem(LANGUAGE_CHOSEN_KEY, '1');
  } catch {
    /* приватный режим без localStorage */
  }
}

/** Пользователь сам выбрал перевод — не сбрасываем его на перевод по умолчанию для языка. */
export function rememberTranslationChoice(translationId) {
  if (typeof window === 'undefined' || !translationId) return;
  try {
    localStorage.setItem(TRANSLATION_KEY, translationId);
    localStorage.setItem(TRANSLATION_CHOSEN_KEY, '1');
  } catch {
    /* приватный режим без localStorage */
  }
}

/**
 * Каждый запуск: пока язык не выбран явно, берём его из Telegram или браузера.
 * Перевод без явного выбора следует за языком.
 */
export function bootstrapLocale() {
  if (typeof window === 'undefined') return;
  try {
    let lang = localStorage.getItem(LANGUAGE_KEY);
    if (!localStorage.getItem(LANGUAGE_CHOSEN_KEY) || !lang) {
      lang = detectUiLanguage();
      localStorage.setItem(LANGUAGE_KEY, lang);
    }

    const translation = localStorage.getItem(TRANSLATION_KEY);
    const translationChosen = Boolean(localStorage.getItem(TRANSLATION_CHOSEN_KEY));
    if (!translation || (!translationChosen && LANGUAGE_BY_TRANSLATION[translation] !== lang)) {
      localStorage.setItem(TRANSLATION_KEY, DEFAULT_TRANSLATION[lang] || DEFAULT_TRANSLATION[FALLBACK_UI_LANGUAGE]);
    }
  } catch {
    /* приватный режим без localStorage */
  }
}
